if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
          configureZoomThumbnails();
      }
    }
  );
}

function configureZoomThumbnails(){  
  const zoomImagesContainer = document.querySelector(".zoom-img");  
  const zoomImgs = Array.from(zoomImagesContainer.querySelectorAll("img"));  
  const parentThumbnail = document.querySelector(".product-zoom-thumbnails");  
  const thumbnailImgs = Array.from(parentThumbnail.querySelectorAll("img"));  
  
  const cleanSrc = (url) => url.split("?")[0]; // function to give clean url
  const activeZoomImg = zoomImgs.find(img => img.classList.contains("active"));  
  if(activeZoomImg){
  const activeZoomSrc = cleanSrc(activeZoomImg.getAttribute("src"));
    thumbnailImgs.forEach(thumb => {
      const thumbSrc = cleanSrc(thumb.getAttribute("src"));
      if (thumbSrc === activeZoomSrc) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });  
    thumbnailImgs.forEach(thumbnail => {
      thumbnail.addEventListener("click", () => {
        const clickedSrc = cleanSrc(thumbnail.getAttribute("src"));  
        thumbnailImgs.forEach(img => img.classList.remove("active"));
        zoomImgs.forEach(img => img.classList.remove("active"));  
        thumbnail.classList.add("active");  
        const matchedZoomImg = zoomImgs.find(zoomImg =>
          cleanSrc(zoomImg.getAttribute("src")) === clickedSrc
        );
        if (matchedZoomImg) {
          matchedZoomImg.classList.add("active");
        }
      });
    });
  }  
}
